<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>位置：</el-breadcrumb-item>
      <el-breadcrumb-item>营销管理</el-breadcrumb-item>
      <el-breadcrumb-item>信息发布</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="info_tabs">
      <div :class="index == '1' ? 'tabs_active' : ''" @click="tabClick('1')">
        景区动态
      </div>
      <div :class="index == '2' ? 'tabs_active' : ''" @click="tabClick('2')">
        旅游攻略
      </div>
    </div>
    <el-card class="conentBox" v-if="index == 1">
      <el-row class="conentRow">
        <div>
          <el-col class="conentCol">
            <el-input placeholder="请输入关键字" clearable v-model="data.title" />
          </el-col>
          <el-col class="conentColSele">
            <el-select
              v-model="data.typeid"
              placeholder="全部分类"
              clearable
            >
              <el-option
                v-for="item in typeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col class="conentBtn" style="width: auto">
            <el-button type="primary" @click="chaxunBtns">查询</el-button>
          </el-col>
        </div>
        <div class="addBtns">
          <div @click="addInfo">
            <img src="@/assets/add.png" alt="" />
            <span>添加信息</span>
          </div>
        </div>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
      >
        <el-table-column  label="分类">
            <template slot-scope="scope">
              {{scope.row.type_id=='1'?'运营信息':scope.row.type_id=='2'?'票务政策':scope.row.type_id=='3'?'实时服务提醒':scope.row.type_id=='4'?'活动与节庆预告':'安全与防疫提示'}}
            </template>
        </el-table-column>
        <el-table-column prop="title" label="名称"></el-table-column>
        <el-table-column prop="abstract" label="摘要"></el-table-column>
        <!-- <el-table-column prop="address" label="状态">
          <template slot-scope="scope">
            <div
              class="cursor"
              v-if="scope.row.UseFlag == '0'"
              @click="setup(1, scope.row.ProductID)"
            >
              <img src="@/images/scenic/dl.png" alt />
              <span style="margin-left: 9px">上线</span>
            </div>
            <div
              class="cursor"
              v-if="scope.row.UseFlag == '1'"
              @click="setup(0, scope.row.ProductID)"
            >
              <img src="@/images/scenic/dh.png" alt />
              <span style="margin-left: 9px">下线</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="createtime" label="发布时间"></el-table-column>
        <el-table-column prop="address" label="操作" width="200"    fixed="right">
          <template slot-scope="scope">
            <div>
              <span class="detele" @click="deteleClick(scope.row)">删除</span>
              <span class="detail" @click="addsinfo(scope.row)">详情</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{ total }}条记录，</span>
        <span class="demonstration">当前显示第{{ data.page }}页</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="data.page_size"
          :current-page="data.page"
          @current-change="currenchange"
        ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <el-card class="conentBox" v-if="index == 2">
      <el-row class="conentRow">
        <div>
          <el-col class="conentCol">
            <el-input placeholder="请输入关键字"  clearable v-model="data.title" />
          </el-col>
          <el-col class="conentBtn" style="width: auto">
            <el-button type="primary" @click="chaxunBtns">查询</el-button>
          </el-col>
        </div>
        <div class="addBtns">
          <div @click="addInfo">
            <img src="@/assets/add.png" alt="" />
            <span>添加信息</span>
          </div>
        </div>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        :row-class-name="tableRowClassName"
        :cell-style="cellStyle"
      >
      <el-table-column prop="title" label="分类">
        <template slot-scope="scope">
              <span>{{scope.row.recommend_flag=='1'?'热门推荐':'暂不推荐'}}</span>
          </template>
      </el-table-column>

        <el-table-column prop="title" label="名称"></el-table-column>
        <el-table-column prop="abstract" label="摘要"></el-table-column>
        <el-table-column prop="createtime" label="发布时间"></el-table-column>
        <el-table-column prop="address" label="操作" width="200"    fixed="right">
          <template slot-scope="scope">
            <div>
              <span class="detele" @click="deteleClick(scope.row)">删除</span>
              <span class="detail" @click="addsinfo(scope.row)">详情</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{ total }}条记录，</span>
        <span class="demonstration">当前显示第{{ page }}页</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="data.page_size"
          :current-page="data.page"
          @current-change="currenchange"
        ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      title="添加信息"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      width="740px"
      center
    >
      <div class="info_dialogs">
        <el-form :label-position="labelPosition"
          :model="ruleForm"
          ref="ruleForms"
          label-width="78px">
          <el-form-item label="标题名称:"> 
            <el-input placeholder="请输入" v-model="ruleForm.title"></el-input>
          </el-form-item>
          <el-form-item label="信息分类:"  v-if="index!=2">
            <el-select
              v-model="ruleForm.type_id"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in typeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="热门推荐:" v-if="index==2">
            <el-select
              v-model="ruleForm.recommend_flag"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in typeArrs"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="信息摘要:"> 
            <el-input placeholder="请输入" v-model="ruleForm.abstract"></el-input>
          </el-form-item>
          <el-form-item label="产品封面:"> 
              <div class="fengmian">
                <el-upload
                  class="avatar-uploader"
                  action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :data="datas">
                  <img v-if="ruleForm.img" :src="ruleForm.img" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon">
                  </i>
                </el-upload>
                <span>
                  注：请上传1M一下的图片(此图片用于平台宣传，请认证对待)，支持png、jpg、jpeg
                </span>
              </div>
          </el-form-item>
          <el-form-item label="信息链接:"> 
            <el-input placeholder="请输入" v-model="ruleForm.link"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog_btns">
          <div @click="clearClick">清空</div>
          <div @click="submit">确认添加</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { sendNotice , noticeList , deleteNoticeInfo}  from '@/request/scenic.js'
import {Message, MessageBox } from 'element-ui'
export default {
  data() {
    return {
      labelPosition: "right",
      ruleForm:{
        token:window.sessionStorage.getItem('Token'),
        type:'',
        title:'',
        recommend_flag:'',
        img:'',
        type_id:'',
        abstract:'',
        link:'',
        id:''
      },
      typeArrs:[
        {
          value:1,
          label:'是',
        },
        {
          value:2,
          label:'否',
        }
      ],
      typeArr:[
        {
          value:1,
          label:'运营信息',
        },
        {
          value:2,
          label:'票务政策',
        },{
          value:3,
          label:'实时服务提醒',
        },{
          value:4,
          label:'活动与节庆预告',
        },{
          value:5,
          label:'安全与防疫提示',
        }
      ],
      addProDialogVisible: false,
      tableData: [{}],
      index: 1,
      data: {
        token: window.sessionStorage.getItem("Token"),
        type:'1',
        title:'',
        typeid:'',
        page_size:8,
        page:1
      },
      datas:{
        token: window.sessionStorage.getItem("Token"),
      },
      name: "",
      total:0
    };
  },
  created(){
    this.getList()
  },
  methods: {
    clearClick(){
      if(this.index=='1'){
        this.ruleForm.recommend_flag = '2'
      }else{
        this.ruleForm.recommend_flag = ''
      }
      this.ruleForm.title = ''
      this.ruleForm.img = ''
      this.ruleForm.abstract = ''
      this.ruleForm.link = ''
      this.ruleForm.type_id = ''
    },
    chaxunBtns(){
      this.data.page = 1
      this.getList()
    },
    deteleClick(row){
      MessageBox('此操作删除该动态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let data = {
              token: window.sessionStorage.getItem("Token"),
              id:row.id   
            }
            deleteNoticeInfo(data).then(res=>{
              if(res.data.rcode=='200'){
                this.data.page = 1
                this.getList()
                this.$message.success('删除动态成功')
              }else{
                this.$message.error(res.data.msg)
              }
            })
        }).catch(() => {
                 
        });
    },
    getList(){
      this.data.type = this.index
      noticeList(this.data).then(res=>{
        if(res.data.rcode==200){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    submit(){
        if(this.ruleForm.title==''){
          Message.error('请输入标题名称')
          return false
        }
        // if(this.ruleForm.img==''){
        //   Message.error('请上传图片')
        //   return false
        // }
        if(this.ruleForm.abstract==''){
          Message.error('请输入信息摘要')
          return false
        }
        // if(this.ruleForm.link==''){
        //   Message.error('请输入信息链接')
        //   return false
        // }else{
        //   let reg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
        //   if (!reg.test(this.ruleForm.link)) {
        //     Message.error('请输入正确的链接')
        //     return false
        //   } else {
        //   }
        // }
      if(this.index==1){
        if(this.ruleForm.type_id==''){
          Message.error('请选择信息分类')
          return false
        }
        sendNotice(this.ruleForm).then(res=>{
          if(res.data.rcode=='200'){
            this.addProDialogVisible = false
            if(this.ruleForm.id){
              Message.success('修改成功')
            }else{
              Message.success('添加成功')
            }
            this.ruleForm = {
              token:window.sessionStorage.getItem('Token'),
              type:'',
              title:'',
              recommend_flag:'',
              img:'',
              type_id:'',
              abstract:'',
              link:'',
              id:''
            }
            this.getList()
          }else{
            Message.error(res.data.msg)
          }
        })
      }else{
        if(this.ruleForm.recommend_flag==''){
          Message.error('请选择是否推荐')
          return false
        }
        sendNotice(this.ruleForm).then(res=>{
          if(res.data.rcode=='200'){
            this.addProDialogVisible = false
            if(this.ruleForm.id){
              Message.success('修改成功')
            }else{
              Message.success('添加成功')
            }
            this.ruleForm = {
              token:window.sessionStorage.getItem('Token'),
              type:'',
              title:'',
              recommend_flag:'',
              img:'',
              type_id:'',
              abstract:'',
              link:'',
              id:''
            }
            this.getList()
          }else{
            Message.error(res.data.msg)
          }
        })
      }
    },
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    addsinfo(row){
      this.ruleForm = {
          token:window.sessionStorage.getItem('Token'),
          type:row.type,
          title:row.title,
          recommend_flag:row.recommend_flag,
          img:row.img,
          type_id:row.type_id,
          abstract:row.abstract,
          link:row.link,
          id:row.id
      }
      this.addProDialogVisible = true
    },
    addInfo(){
      this.ruleForm.type = this.index
      if(this.index=='1'){
        this.ruleForm.recommend_flag = '2'
      }else{
      }
      this.addProDialogVisible = true
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.img = res.result
    },
    addProHandleClose() {
      this.addProDialogVisible = false;
      this.ruleForm = {
      token:window.sessionStorage.getItem('Token'),
      type:'',
      title:'',
      recommend_flag:'',
      img:'',
      type_id:'',
      abstract:'',
      link:'',
      id:''
    }
    },
    tabClick(e) {
      if (this.index == e) {
        return false;
      }
      this.index = e;
      this.data.page = 1
      this.data.title = ''
      this.data.typeid = ''
      this.getList()
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex,
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.dialog_btns{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  >div{
    width: 10rem;
    height: 4rem;
    color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    &:nth-child(1){
      margin-right: 2rem;
      background: #D9D9D9;
    }
    &:nth-child(2){
      background: #246deb;
    }
  }
}
.info_dialogs {
  padding: 2rem;
  box-sizing: border-box;
  border-top: 1px solid #e5e5ea;
  ::v-deep .el-select{
    width: 100%;
  }
  .fengmian{
    display: flex;
    >span{
      margin-left: 2rem;
      color: #FF4D4F;
      font-size: 1.4rem;
      line-height: 1.4rem;
      margin-top: auto;
      display: block;
    }
  }
  .avatar-uploader{
    width: 23rem;
    height: 13rem;
    border-radius: 0.8rem;
    border: 1px solid #E5E5EA;
    img{
      width: 100%;
      height: 100%;
    }
    ::v-deep .el-upload{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-icon-plus{
        font-size: 2.8rem;
      }
    }
  }
}
.conentBox {
  margin-top: 17px;
  .conentRow {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div:nth-child(1) {
      // width: 50%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .conentCol {
        width: 40rem;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;
        /deep/.el-input {
          width: 100%;
        }
      }
      .conentColSele {
        margin-right: 10px;
        margin-bottom: 10px;
        width: 260px;
        position: relative;
        /deep/.el-select {
          width: 100%;
        }
      }
      .conentBtn {
        margin-bottom: 10px;
        // width: 120px;
        .el-button {
          width: 100px;
          // width: 84%;
          background: #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    > div:nth-child(2) {
      // width: 50%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
      margin-left: auto;
      .scenicBtnDel {
        .el-button {
          width: 92px;
          background: #ffffff;
          border: 1px solid #ff4d4f;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ff4d4f;
          box-sizing: border-box;
        }
      }
      .scenicBtnPx {
        margin: 0 20px;
        .el-button {
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          /* identical to box height */
          box-sizing: border-box;
          color: #246deb;
        }
      }
      .scenicBtn {
        .el-button {
          width: 120px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          box-sizing: border-box;
          color: #246deb;
        }
      }
    }
  }
}
.info_tabs {
  display: flex;
  align-items: center;
  margin-top: 2rem;
  > div {
    margin-right: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 11.6rem;
    height: 4rem;
    border-radius: 0.4rem;
    color: #fff;
    font-size: 1.4rem;
    background: #d9d9d9;
    cursor: pointer;
  }
  .tabs_active {
    background: #246deb;
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.addBtns {
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12rem;
    height: 4rem;
    border-radius: 0.4rem;
    border: 1px solid #246deb;
    color: #246deb;
    cursor: pointer;
    img {
      width: 1.4rem;
      height: 1.4rem;
      margin-right: 1rem;
    }
  }
}
.detele {
  color: #ff4d4f;
  margin-right: 2rem;
  font-size: 1.4rem;
  cursor: pointer;
}
.detail {
  color: #246deb;
  font-size: 1.4rem;
  cursor: pointer;
}
</style>
